module.exports = __webpack_public_path__ + "img/1.7c09af64.svg";